<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <TabsWidget activeTab="tv_stream" @selected="switchTab"></TabsWidget>
      <div class="tab-options">
        <b-button type="is-dark" v-if="stream_data && !is_waiting_streamed_video" :loading="end_stream_loading" outlined
          @click="endStream()">END
          STREAM</b-button>
        <b-button type="is-dark" v-if="stream_data && is_waiting_streamed_video" outlined
          :loading="close_stream_loading" @click="closeStream()">CLOSE
          STREAM</b-button>
        <b-button type="is-primary" v-else-if="!stream_data_loading && !stream_data" :loading="add_stream_loading"
          outlined @click="startNewStream()">START NEW TV STREAM</b-button>
      </div>
    </div>
    <div class="wrapper-body">
      <div v-if="!stream_data_loading && stream_data" class="left-panel">
        <div class="video-preview-widget">
          <div v-if="!form.allowStreamFromOtherSource" class="video-preview-widget-container">
            <div v-if="is_waiting_streamed_video" class="video-preview-widget-loading-widget">
              <div class="video-preview-loader">
                <loading :height="100" color="#fff" :opacity="1" :width="100" :active.sync="is_waiting_streamed_video"
                  :is-full-page="false" :can-cancel="false" background-color="#000" class="loader"></loading>
              </div>
              <div class="video-preview-waiting">
                <h4>Connect streaming software to go live</h4>
                <h3>Your TV channel will be available once you go live</h3>
              </div>
            </div>
            <div v-else class="video-player-widget">
              <ClapprPlayer v-if="playerType == 'clappr'"
                :src="`${playbackType == 'hls' ? hlsStreamingPath : dashStreamingPath}`" :type="playbackType">
              </ClapprPlayer>
              <OvenPlayer v-else-if="playerType == 'oven'" :webRTCUrl="`${webRtcStreamingPath}`" :muted="true"
                :latency="form.stream_latency">
              </OvenPlayer>
            </div>
          </div>
          <div v-if="form.allowStreamFromOtherSource" class="video-preview-widget-container">
            <div class="video-player-widget">
              <YTPlayer v-if="form.otherSourceUrl" :url="form.otherSourceUrl"></YTPlayer>
            </div>
          </div>
          <div class="stream-details">
            <div class="stream-details-item space-between">
              <div class="stream-details-content">
                <div class="field-title">TV Channel Title</div>
                <div class="field-value">{{ form.title }}</div>
              </div>
              <div class="stream-details-options">
                <b-button @click="showUpdateDetailsModal()" type="is-primary" class="edit-btn">EDIT</b-button>
              </div>
            </div>
            <div class="stream-details-item">
              <div class="stream-details-content">
                <div class="field-title">Channel Link</div>
                <div class="field-value link">
                  <a target="_blank" class="crop-text"
                    :href="`${$store.state.SITE_BASE_URL}watch/tv/${stream_data.id}/${stream_data.slug}`" v-html="`${$store.state.SITE_BASE_URL}watch/tv/${stream_data.id}/${stream_data.slug}`
                      "></a>
                </div>
              </div>
            </div>
            <div class="stream-details-item">
              <div class="stream-details-content">
                <div class="field-title" style="margin-bottom: 8px;">Status
                  <b-tooltip type="is-dark" position="is-bottom">
                    <img width="15" src="@/assets/images/icons/info.svg">
                    <template v-slot:content>
                      <p>
                        <b>Published</b> - Your TV channel is live and available to viewers
                      </p>
                      <p>
                        <b>Unlisted</b> - Your TV channel is live but only accessible via direct link
                      </p>
                    </template>
                  </b-tooltip>
                </div>
                <div class="field-value link">
                  <b-field>
                    <p class="control">
                      <b-button :type="form.visibility == 'Published' ? 'is-success' : ''" :label="form.visibility" />
                    </p>
                    <p class="control">
                      <b-dropdown animation="none">
                        <template #trigger>
                          <b-button icon-left="menu-down" />
                        </template>
                        <b-dropdown-item @click="form.visibility = 'Published'">Published</b-dropdown-item>
                        <b-dropdown-item @click="form.visibility = 'Unlisted'">Unlisted</b-dropdown-item>
                      </b-dropdown>
                    </p>
                  </b-field>
                </div>
              </div>
            </div>

            <div class="stream-details-item">
              <div class="stream-details-content">
                <div class="field-title">
                  {{
                    is_waiting_streamed_video
                      ? "Viewers waiting"
                      : "Viewers watching"
                  }}
                </div>
                <div class="field-value">
                  {{ users_current_live }}
                  {{ is_waiting_streamed_video ? " waiting" : "watching" }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="stream-status-widget" v-if="!form.allowStreamFromOtherSource">
          <div class="stream-dot" :class="{ active: !is_waiting_streamed_video }"></div>
          <div class="stream-status" v-if="is_waiting_streamed_video">
            Start sending your video feed to begin broadcasting
          </div>
          <div class="stream-status" v-else>TV Channel is now live</div>
        </div>
        <div class="stream-status-widget" v-else>
          <div class="stream-dot active"></div>
          <div class="stream-status">Ready to stream from other source</div>
        </div>
        <div class="stream-tab-header">
          <div class="tabs-widget">
            <div class="tab-item" :class="{ active: stream_tab == 'settings' }" @click="switchStreamTab('settings')">
              STREAM SETTINGS
            </div>
            <div class="h-spacer"></div>
            <div class="tab-item" :class="{ active: stream_tab == 'health' }" @click="switchStreamTab('health')">
              STREAM HEALTH
            </div>
            <div class="h-spacer"></div>
            <div class="tab-item" :class="{ active: stream_tab == 'logs' }" @click="switchStreamTab('logs')">
              STREAM LOGS
            </div>
            <div class="h-spacer"></div>
            <div class="tab-item" :class="{ active: stream_tab == 'analytics' }" @click="switchStreamTab('analytics')">
              VIEWS ANALYTICS
            </div>
          </div>
          <div class="tab-options"></div>
        </div>
        <div v-if="stream_tab == 'settings'" class="settings-container">
          <!-- Public HLS URL Section -->
          <div class="settings-section" v-if="hlsStreamingPath">
            <div class="settings-section-header">
              <h3>Public Streaming URL</h3>
              <div class="settings-section-subtitle">Share this URL for external players and integrations</div>
            </div>
            <div class="settings-section-content">
              <div class="url-display-container">
                <div class="url-display">
                  <div class="url-label">HLS Stream URL</div>
                  <div class="url-input-container">
                    <b-input v-model="hlsStreamingPath" readonly class="url-input" type="text">
                    </b-input>
                    <b-button @click="copyHlsUrl" type="is-primary" class="copy-btn"
                      :class="{ 'is-success': copySuccessHls }" outlined>
                      {{ copySuccessHls ? 'COPIED!' : 'COPY' }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Stream Settings Component -->
          <EventStreamSettings v-if="channel" :form="form" :isPlaying="!is_waiting_streamed_video"
            @updated="onSettingsUpdated" :isTvStream="true">
          </EventStreamSettings>
        </div>
        <EventStreamHealth v-if="stream_tab == 'health'" :form="form" :event="stream_data" :streamKey="form.stream_key"
          :status="stream_status">
        </EventStreamHealth>
        <EventStreamLogs v-if="stream_tab == 'logs' && stream_data" :form="form" :event="stream_data"
          :streamKey="form.stream_key"></EventStreamLogs>
        <EventStreamAnalytics v-if="stream_tab == 'analytics' && stream_data" :event="stream_data">
        </EventStreamAnalytics>
      </div>
      <div v-if="!stream_data_loading && !stream_data" class="left-panel">
        <widgetNotfound title="No TV Stream Found" subtitle="Click on Start New TV Stream to begin broadcasting">
        </widgetNotfound>
      </div>

      <div v-if="stream_data_loading" class="left-panel">
        <div class="loading-container">
          <loading :height="70" color="#000" :opacity="1" :width="70" :active.sync="stream_data_loading"
            :is-full-page="false" :can-cancel="false" background-color="#ffffff" class="content-loader"></loading>
        </div>
      </div>
    </div>

    <!-- Update Stream details modal -->
    <UpdateStreamDetailsModal v-if="show_update_stream_details_modal" :stream="stream_data" :isTvStream="true"
      @saved="onStreamDetailsSaved" @close="show_update_stream_details_modal = false"></UpdateStreamDetailsModal>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import UpdateStreamDetailsModal from "./modals/EventUpdateStreamDetailsModal.vue";
import EventStreamSettings from "./components/EventStreamSettings.vue";
import EventStreamHealth from "./components/EventStreamHealth.vue";
import EventStreamLogs from "./components/EventStreamLogs.vue";
import EventStreamAnalytics from "./components/EventStreamAnalytics.vue";
import TabsWidget from "./components/TabsWidget.vue";
import { MEDIA_SERVER_BASE_URL, STREAMING_CDN_SERVER_BASE_URL, LIVE_STREAMING_CDN_SERVER_BASE_URL } from "@/store/variables.js";

export default {
  components: {
    UpdateStreamDetailsModal,
    EventStreamSettings,
    EventStreamHealth,
    EventStreamLogs,
    EventStreamAnalytics,
    TabsWidget,
  },
  data: () => ({
    show_player: true,
    users_current_live: 0,
    is_waiting_streamed_video: true,
    playerType: "clappr",
    playbackType: "hls",
    dashStreamingPath: "",
    hlsStreamingPath: "",
    webRtcStreamingPath: "",
    stream_data: null,
    stream_data_loading: false,
    form: {
      id: null,
      title: "Untitled TV Channel",
      channel_id: null,
      category: "tv",
      visibility: "Unlisted",
      stream_key: "",
      stream_url: "",
      stream_latency: "normal",
      allow_payment: false,
      keep_video: false,
      show_views: false,
      allow_chat: false,
      allow_super_chat: false,
      allow_remote_input: false,
      remote_input_headers: "",
      player_url: "",
      allowStreamFromOtherSource: false,
      otherSourceUrl: "",
      donationId: null,
    },
    add_stream_loading: false,
    show_update_stream_details_modal: false,
    stream_tab: "settings",
    update_stream_setting_loading: false,
    channel: null,
    streamingStatusTimer: null,
    whoseWatchingTimer: null,
    close_stream_loading: false,
    end_stream_loading: false,
    stream_status: "",
    copySuccessHls: false,
  }),
  watch: {
    form: {
      handler: function (form) {
        let vm = this;
        vm.onSettingsUpdated(form);
      },
      deep: true,
    },
  },
  mounted() {
    let vm = this;
    vm.getMyChannelDetails();
    vm.checkStreamingStatus();
    vm.whoseWatchingTimer = setInterval(function () {
      vm.countWhoseWatching();
    }, 1000 * 5);
  },
  beforeDestroy() {
    let vm = this;
    clearInterval(vm.streamingStatusTimer);
    clearInterval(vm.whoseWatchingTimer);
  },
  methods: {
    checkStreamingStatus() {
      let vm = this;
      vm.streamingStatusTimer = setInterval(function () {
        if (vm.channel && vm.channel.event_live_input.stream_key && vm.stream_data) {
          vm.$store
            .dispatch("STREAMING_CHECK_STREAM_STATUS", {
              stream_key: vm.channel.event_live_input.stream_key,
              activeStreamId: vm.stream_data.id
            })
            .then((response) => {
              vm.stream_status = response.data.return;
              if (response.data.return == "offline") {
                vm.hlsStreamingPath = "";
                vm.dashStreamingPath = "";
                vm.webRtcStreamingPath = "";
                vm.is_waiting_streamed_video = true;
              } else if (response.data.return == "live") {
                if (vm.is_waiting_streamed_video) {
                  vm.stream_data.session_id = response.data.stream.session_id;
                  vm.hlsStreamingPath = LIVE_STREAMING_CDN_SERVER_BASE_URL + "/watch.rw/" + response.data.stream.session_id + "/master.m3u8";
                  vm.dashStreamingPath = LIVE_STREAMING_CDN_SERVER_BASE_URL + "/watch.rw/" + response.data.stream.session_id + "/manifest.mpd";
                  vm.is_waiting_streamed_video = false;
                }
              } else {
                vm.hlsStreamingPath = "";
                vm.dashStreamingPath = "";
                vm.webRtcStreamingPath = "";
                vm.is_waiting_streamed_video = true;
              }
            })
            .catch(({ response }) => {
            });
        }
      }, 1000 * 5);
    },
    countWhoseWatching() {
      let vm = this;
      if (vm.stream_data) {
        const payload = {
          stream_id: vm.stream_data.id,
          isLive: true
        }
        vm.$store
          .dispatch("STREAMING_GET_EVENT_VIEWS", payload)
          .then((response) => {
            vm.users_current_live = response.data.return.views;
          })
          .catch(({ response }) => { });
      }
    },
    getMyChannelDetails() {
      let vm = this;
      vm.stream_data_loading = true;
      vm.$store
        .dispatch("CHANNEL_GET_MY_DETAILS")
        .then((response) => {
          vm.form.channel_id = response.data.return.id;
          vm.channel = response.data.return;
          vm.getMyActiveStream();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    switchStreamTab(tab) {
      let vm = this;
      vm.stream_tab = tab;
    },
    onStreamDetailsSaved(data) {
      let vm = this;
      vm.show_update_stream_details_modal = false;
      vm.stream_data = data;
      vm.updateFields(vm.stream_data);
    },
    showUpdateDetailsModal() {
      let vm = this;
      vm.show_update_stream_details_modal = true;
    },
    updateFields(item) {
      let vm = this;
      vm.form.id = item.id;
      vm.form.title = item.title;
      vm.form.channel_id = item.channel_id;
      vm.form.category = item.category;
      vm.form.visibility = item.visibility;
      vm.form.allow_payment = item.allow_payment == 1 ? true : false;
      vm.form.keep_video = item.keep_stream == 1 ? true : false;
      vm.form.show_views = item.show_views == 1 ? true : false;
      vm.form.allow_chat = false; // Always false for TV streams
      vm.form.allow_super_chat = false; // Always false for TV streams
      vm.form.allow_remote_input = false;
      vm.form.remote_input_headers = false;
      vm.form.player_url = item.player_url;
      vm.form.allowStreamFromOtherSource = item.allowStreamFromOtherSource == 1 ? true : false;
      vm.form.otherSourceUrl = item.otherStreamSourceUrl;
      vm.form.donationId = item.donationId;
      vm.form.stream_key = vm.channel.event_live_input.stream_key;
      vm.form.stream_url = vm.channel.event_live_input.stream_url;
      vm.form.stream_latency = item.stream_latency;
    },
    onSettingsUpdated(form) {
      let vm = this;
      vm.form = form;
      if (vm.form.id && !vm.update_stream_setting_loading) {
        vm.update_stream_setting_loading = true;
        vm.$store
          .dispatch("STREAMING_UPDATE_MY_STREAM", vm.form)
          .then((response) => {
            vm.update_stream_setting_loading = false;
            vm.$buefy.toast.open({
              message: "TV Channel settings updated",
              type: "is-success",
            });
          })
          .catch(({ response }) => {
            vm.update_stream_setting_loading = false;
          });
      }
    },
    startNewStream() {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: "Start a new TV channel",
        message:
          "Are you sure you want to start a new TV channel? This will close the current channel if active.",
        confirmText: "Start",
        type: "is-warning",
        hasIcon: true,
        onConfirm: () => {
          vm.add_stream_loading = true;
          vm.form.title = "Untitled TV Channel";
          vm.form.category = "tv";
          vm.form.visibility = "Unlisted";
          vm.form.allowStreamFromOtherSource = false;
          vm.form.otherSourceUrl = "";
          vm.form.allow_chat = false;
          vm.form.allow_super_chat = false;
          vm.$store
            .dispatch("STREAMING_ADD_MY_STREAM", vm.form)
            .then((response) => {
              vm.add_stream_loading = false;
              vm.$notify({
                group: "status",
                type: "success",
                title: "TV Channel Created",
                text: response.data.message,
              });
              vm.getMyActiveStream();
            })
            .catch(({ response }) => {
              vm.add_stream_loading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: response.data.message,
              });
            });
        },
      });
    },
    closeStream() {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: "Close TV channel",
        message:
          "Are you sure you want to close the TV channel?",
        confirmText: "Close",
        type: "is-warning",
        hasIcon: true,
        onConfirm: () => {
          vm.initiateCloseStream();
        },
      });
    },
    initiateCloseStream() {
      let vm = this;
      vm.close_stream_loading = true;
      vm.$store
        .dispatch("STREAMING_CLOSE_MY_STREAM", {
          event_id: vm.form.id,
          channel_id: vm.form.channel_id,
          stream_key: vm.form.stream_key,
        })
        .then((response) => {
          vm.close_stream_loading = false;
          vm.$notify({
            group: "status",
            type: "success",
            title: "TV Channel Closed",
            text: response.data.message,
          });
          vm.getMyActiveStream();
        })
        .catch(({ response }) => {
          vm.close_stream_loading = false;
          vm.$notify({
            group: "status",
            type: "warn",
            title: "OOPS!!!",
            text: response.data.message,
          });
        });
    },
    endStream() {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: "End TV channel",
        message:
          "Are you sure you want to end the TV channel?",
        confirmText: "End",
        type: "is-warning",
        hasIcon: true,
        onConfirm: () => {
          vm.end_stream_loading = true;
          vm.$store
            .dispatch("STREAMING_END_MY_STREAM", {
              event_id: vm.form.id,
              stream_key: vm.form.stream_key,
              sessionId: vm.stream_data.session_id,
            })
            .then((response) => {
              vm.end_stream_loading = false;
              vm.$notify({
                group: "status",
                type: "success",
                title: "TV Channel Ended",
                text: response.data.message,
              });
              vm.initiateCloseStream();
            })
            .catch(({ response }) => {
              vm.end_stream_loading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: response.data.message,
              });
            });
        },
      });
    },
    getMyActiveStream() {
      let vm = this;
      vm.stream_data_loading = true;
      vm.$store
        .dispatch("STREAMING_GET_MY_ACTIVE_STREAM")
        .then((response) => {
          vm.stream_data_loading = false;
          vm.stream_data = response.data.return;
          vm.updateFields(vm.stream_data);
          vm.countWhoseWatching();
          if (
            vm.channel.event_live_input.input_status == "live" &&
            vm.channel.event_live_input.stream_key
          ) {
            vm.hlsStreamingPath = LIVE_STREAMING_CDN_SERVER_BASE_URL + "/watch.rw/" + vm.stream_data.session_id + "/master.m3u8";
            vm.dashStreamingPath = LIVE_STREAMING_CDN_SERVER_BASE_URL + "/watch.rw/" + vm.stream_data.session_id + "/manifest.mpd";
            vm.is_waiting_streamed_video = false;
          } else {
            vm.hlsStreamingPath = "";
            vm.dashStreamingPath = "";
            vm.webRtcStreamingPath = "";
            vm.is_waiting_streamed_video = true;
          }
        })
        .catch(({ response }) => {
          vm.stream_data_loading = false;
        });
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
    copyHlsUrl() {
      let vm = this;
      if (vm.hlsStreamingPath) {
        navigator.clipboard.writeText(vm.hlsStreamingPath).then(() => {
          vm.copySuccessHls = true;
          vm.$buefy.toast.open({
            message: "HLS URL copied to clipboard!",
            type: "is-success",
          });
          setTimeout(() => {
            vm.copySuccessHls = false;
          }, 2000);
        }).catch(() => {
          // Fallback for older browsers
          const textArea = document.createElement('textarea');
          textArea.value = vm.hlsStreamingPath;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);

          vm.copySuccessHls = true;
          vm.$buefy.toast.open({
            message: "HLS URL copied to clipboard!",
            type: "is-success",
          });
          setTimeout(() => {
            vm.copySuccessHls = false;
          }, 2000);
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;
        white-space: nowrap;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 60px);
    display: flex;

    @media (max-width: 780px) {
      flex-direction: column;
      overflow-y: auto;
      background-color: #fff;
    }

    .left-panel {
      height: 100%;
      width: 100%;
      background: #fff;
      transition: all 0.3s ease;
      display: flex;
      flex-direction: column;

      @media (max-width: 650px) {
        height: unset;
      }

      .loading-container {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
      }

      .video-preview-widget {
        height: 300px;
        width: 100%;
        display: flex;
        padding: 20px 10px;

        @media (max-width: 650px) {
          flex-direction: column;
          height: unset;
        }

        .video-preview-widget-container {
          width: 55%;
          height: 100%;
          display: flex;

          @media(max-width: 1133px) {
            width: 100%;

            .video-preview-widget-loading-widget {
              background: none !important;
            }
          }

          @media (max-width: 650px) {
            margin-bottom: 15px;
          }

          @media (max-width: 650px) {
            flex-direction: column;
            height: unset;
          }

          .video-preview-widget-loading-widget {
            height: 100%;
            width: 100%;
            background: #000;
            border-radius: 5px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .video-preview-loader {
              position: relative;
            }

            .video-preview-waiting {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;

              h4 {
                color: #fff;
                margin: 5px 0px;
                font-size: 18px;
              }

              h3 {
                color: rgb(219, 219, 219);
                margin: 5px 0px;
                font-size: 13px;
              }
            }
          }

          .video-player-widget {
            height: 100%;
            width: 100%;
            background: #000;
            border-radius: 5px;
            display: flex;
            overflow: hidden;

            @media (max-width: 1133px) {
              height: 300px;
            }
          }
        }

        .stream-details {
          width: 45%;
          height: 100%;
          display: flex;
          flex-direction: column;
          padding-left: 10px;

          .stream-details-options {
            display: flex;
            column-gap: 5px;
            row-gap: 5px;

            .edit-btn {
              @media (max-width: 780px) {
                display: flex;
              }
            }
          }

          @media (max-width: 1133px) {
            width: 100%;
          }
        }
      }

      .stream-status-widget {
        height: 50px;
        width: 100%;
        display: flex;
        align-items: center;
        border-top: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        padding: 0px 10px;

        .stream-dot {
          height: 15px;
          width: 15px;
          background-color: #ccc;
          border-radius: 50px;
          margin-right: 10px;

          &.active {
            background-color: rgb(3, 206, 64);
          }
        }

        .stream-status {
          font-size: 13px;
        }
      }

      .stream-details-content {
        width: 100%;
      }

      .stream-tab-header {
        width: 100%;
        height: 50px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #ddd;
        padding: 0px 10px;

        .tabs-widget {
          display: flex;
          align-items: flex-end;
          overflow-x: auto;

          .h-spacer {
            margin-right: 20px;
          }

          .tab-item {
            cursor: pointer;
            padding: 14px 4px;
            white-space: nowrap;

            &.active {
              color: var(--wecodefy-secondary-color, #9fc953);
              border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
            }
          }
        }

        .tab-options {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0px 10px;

          .h-spacer {
            margin-right: 10px;
          }
        }
      }
    }
  }
}

// Settings container styling
.settings-container {
  padding: 0px 10px;
  overflow-y: auto;
  height: calc(100% - 50px);
}

.settings-section {
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  .settings-section-header {
    padding: 20px 20px 10px 20px;
    border-bottom: 1px solid #f0f0f0;

    h3 {
      font-size: 16px;
      font-weight: 600;
      color: #333;
      margin: 0 0 5px 0;
    }

    .settings-section-subtitle {
      font-size: 13px;
      color: #666;
      margin: 0;
    }
  }

  .settings-section-content {
    padding: 20px;
  }
}

.url-display-container {
  .url-display {
    .url-label {
      font-size: 12px;
      color: #666;
      text-transform: uppercase;
      font-weight: 600;
      margin-bottom: 8px;
    }

    .url-input-container {
      display: flex;
      gap: 10px;
      align-items: flex-start;

      @media (max-width: 650px) {
        flex-direction: column;
        gap: 8px;
      }

      .url-input {
        flex: 1;
        font-family: 'Monaco', 'Consolas', monospace;
        font-size: 13px;

        @media (max-width: 650px) {
          width: 100%;
        }

        ::v-deep input {
          background-color: #f8f9fa;
          border: 1px solid #e6e6e6;
          border-radius: 6px;
          color: #333;
          font-family: inherit;
          font-size: inherit;
        }
      }

      .copy-btn {
        min-width: 80px;
        transition: all 0.3s ease;
        border-radius: 6px;

        @media (max-width: 650px) {
          width: 100%;
          min-width: unset;
        }

        &.is-success {
          background-color: #28a745;
          border-color: #28a745;
          color: white;
        }
      }
    }
  }
}

// Shared utility classes
.stream-details-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;

  &.space-between {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }

  .field-title {
    font-size: 12px;
    color: #666;
    text-transform: uppercase;
    font-weight: 600;
    margin-bottom: 5px;
  }

  .field-value {
    font-size: 14px;
    color: #333;
    word-break: break-all;

    &.link a {
      color: var(--wecodefy-primary-color, #007bff);
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .h-spacer {
    width: 20px;
  }
}

.crop-text {
  display: block;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
